import React from 'react';
import { Pagination } from 'react-bootstrap';
import "./CustomPagination.css";

const CustomPagination = ({ currentPage, totalPages, onPageChange }) => {
  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 6) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, '...', totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
      }
    }

    return pages;
  };

  const handleClick = (page) => {
    if (page !== '...' && page !== currentPage) {
      onPageChange(page);
    }
  };

  return (
    <Pagination className="custom-pagination justify-content-center">
      <Pagination.Prev
        onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        &lt;
      </Pagination.Prev>

      {getPageNumbers().map((page, idx) =>
        page === '...' ? (
          <Pagination.Ellipsis key={idx} disabled />
        ) : (
          <Pagination.Item
            key={idx}
            active={page === currentPage}
            onClick={() => handleClick(page)}
            style={{ borderRadius: "6px" }}
          >
            {page}
          </Pagination.Item>
        )
      )}

      <Pagination.Next
        onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        &gt;
      </Pagination.Next>
    </Pagination>
  );
};

export default CustomPagination;